// Learner "gelişim" (improvement over time) line chart on the reports Genel durum tab.
// Prefix: ltc-
//
// Solid frost, no live backdrop-filter: this card sits on the long scrolling reports page, and a
// blur that re-rasterizes every scroll frame is the jank the rest of this screen already avoids
// (same reasoning as reportCardViewStyles' qcw- cards).
export const learnerTrendChartStyles = `
.ltc-card {
  border-radius: var(--rad-catchup-xl, 20px);
  border: 1px solid var(--glass-border, rgba(84, 187, 203, 0.2));
  background: var(--glass-flat-solid, rgba(255, 255, 255, 0.86));
  box-shadow: var(--shadow-sm, 0 2px 10px rgba(15, 72, 89, 0.06));
  padding: 16px 18px 18px;
  font-family: var(--font-sans);
}

.ltc-head { margin-bottom: 12px; }
.ltc-title {
  margin: 0;
  font-size: var(--fs-lg);
  font-weight: 700;
  color: var(--catchup-dark-blue, #114859);
}
.ltc-subtitle {
  margin: 4px 0 0;
  font-size: var(--fs-sm);
  color: var(--catchup-gray-500, #6b8c96);
}

.ltc-tabs { margin-bottom: 12px; }

/* The wrapper owns the height: Chart.js runs with maintainAspectRatio false, so without a sized
   parent the canvas collapses. Position is here for the tooltip, which is absolutely placed. */
.ltc-canvas {
  position: relative;
  width: 100%;
}

.ltc-tooltip {
  position: absolute;
  pointer-events: none;
  z-index: 5;
  min-width: 150px;
  max-width: 240px;
  padding: 8px 10px;
  border-radius: var(--rad-catchup-md, 12px);
  border: 1px solid var(--glass-border, rgba(84, 187, 203, 0.24));
  background: var(--glass-flat-solid, rgba(255, 255, 255, 0.96));
  box-shadow: var(--shadow-md, 0 8px 24px rgba(15, 72, 89, 0.16));
  font-family: var(--font-sans);
  transition: opacity 0.15s ease;
}
.ltc-tip-title {
  font-size: var(--fs-sm);
  font-weight: 700;
  color: var(--catchup-dark-blue, #114859);
  word-break: break-word;
}
.ltc-tip-date {
  margin-top: 1px;
  font-size: var(--fs-xs);
  color: var(--catchup-gray-500, #6b8c96);
}
.ltc-tip-rows {
  margin-top: 6px;
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.ltc-tip-row {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: var(--fs-xs);
  color: var(--catchup-dark-blue, #114859);
}
.ltc-tip-dot {
  flex: none;
  width: 8px;
  height: 8px;
  border-radius: 100px;
}
.ltc-tip-label { flex: 1; min-width: 0; }
.ltc-tip-value { font-weight: 700; }

@media (max-width: 768px) {
  .ltc-card { padding: 14px 12px 14px; }
}
`;
